import { render, staticRenderFns } from "./consents_dashboard.vue?vue&type=template&id=695f4f26&scoped=true&"
import script from "./consents_dashboard.vue?vue&type=script&lang=js&"
export * from "./consents_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./consents_dashboard.vue?vue&type=style&index=0&id=695f4f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695f4f26",
  null
  
)

export default component.exports